// Shared styling for "sectioned" modals — the Catalog bulk modals (Assign CPT
// Codes, Quick Add Hearing Aids) and the Exchange Products dialogs — mirroring
// the Bulk Payment wizard's treatment
// (features/billing/.../bulk-payment-step-two.component.tsx): dark green
// title bar, soft shaded section cards, table-style header strip and zebra
// rows. The hex values are the same ones the bulk payment modal uses. Lives
// under components/dialog because it is consumed across features.
import { misc } from "app/themes/colors";

export const MODAL_TITLE_SX = {
  bgcolor: "#12332E",
  color: "#FFFFFF",
  "& .MuiIconButton-root": { color: "#FFFFFF" }
};

export const MODAL_ACTIONS_SX = {
  py: 1,
  px: 2,
  borderTop: "1px solid #E6ECEA",
  backgroundColor: "#FFFFFF"
};

export const SECTION_SX = {
  backgroundColor: "#F7F9F9",
  border: "1px solid #E6ECEA",
  borderRadius: "12px"
};

export const TABLE_HEAD_BG = "#EEF3F1";
export const TABLE_ZEBRA_BG = "#F5F8F7";
export const SECTION_DIVIDER = "#E6ECEA";

// Plain-English caution strip (e.g. "leaving a box empty removes the code").
export const CAUTION_STRIP_SX = {
  display: "flex",
  alignItems: "flex-start",
  gap: 1,
  backgroundColor: misc.lightYellow,
  border: `1px solid ${misc.warningYellow}`,
  borderRadius: "8px",
  px: 1.5,
  py: 1.25
};
